import SnapShotService from "../../apiServices/masters/snapShotService";
import { alertConstants } from "../../helper/sweet-alert";
import {
  setSnapShot,
  setSnapShots,
} from "../../store/slices/master/snapShotSlice";

export function getSnapShot(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await SnapShotService.getSnapShot(id);
    if (response?.success === true) {
      dispatch(setSnapShot(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getSnapShots(configUserRole?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await SnapShotService.getSnapShots(configUserRole);
    if (response?.success === true) {
      dispatch(setSnapShots(response.data));
    } else {
      console.log("error");
    }
  };
}

export function updateSnapShot(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await SnapShotService.updateSnapShot(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}

export function updateVisibility(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await SnapShotService.updateVisibility(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}
